import DashboardWidgetSettings from "@/domain/entities/user/DashboardWidgetSettings";
import { dashboardWidgetSettingsToSDKMapper } from "@/mappers/user/dashboardWidgetSettingsMapper";
import { useUserSettings } from "@cs_teamwaydev/mailvista-sdk_react";
import { useTranslation } from "react-i18next";
import useGetUserProfile from "../useGetUserProfile";
import useErrorToast from "../utils/useErrorToast";

const useSetHomepageSettings = () => {
    const { setDashboardWidgets } = useUserSettings();
    const showToast = useErrorToast();
    const { t } = useTranslation();
    const { data: user } = useGetUserProfile();

    const setDashboardWidgetSettings = async (
        widgetSettings: DashboardWidgetSettings,
    ): Promise<void> => {
        if (!user) {
            throw new Error("User is not available");
        }

        try {
            await setDashboardWidgets(
                dashboardWidgetSettingsToSDKMapper(widgetSettings),
            );
        } catch (error) {
            console.error("Error setting widget settings", error);

            showToast({
                titleTranslationKey: t("errors.widgetsSettings"),
            });
        }
    };

    return { setDashboardWidgetSettings };
};

export default useSetHomepageSettings;
